import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from '../../../models/utilities/filter-bar';
import { ListColumn, SelectedSort } from '../../../models/utilities/list-header';
import { PageData } from '../../../models/utilities/paged-request';
import { ApiEndpoints, GlobalConstants } from '../../../utils/app-constants';
import { AppUtils } from '../../../utils/app-utils';
import { ShipmentType } from '../enums/_index';
import { ShipmentStatusMetadata } from '../enums/shipment-status';

export class TruckSearchFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl          : string = ApiEndpoints.TRANSPORTATION_TRUCKS_SEARCH;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[] = [];
    public selectedSort     : SelectedSort;
    
    constructor(columnNames: string[] = [], filterNames: string[] = []) {

        const listColumns: any = {
            'truckId' : new ListColumn('Truck ID', 'id', true),
            'status' : new ListColumn('Status', ''),
            'name' : new ListColumn('Name', 'name', true),
            'driver' : new ListColumn('Driver', 'driverName', true),
            'cutoff' : new ListColumn('Cutoff', 'cutoff', true),
            'departureDate' : new ListColumn('Departure Date', 'date', true),
            'psSent': new ListColumn('Production Summary', 'psSent', true),
            'pdSent': new ListColumn('Preliminary Delivery', 'pdSent', true),
            'fdSent': new ListColumn('Final Delivery', 'fdSent', true),
        }

        if (columnNames.length == 0) {
            for (let column in listColumns) {
                this.columns.push(listColumns[column]);
            }
        }
        else {
            for (let columnName of columnNames) {
                if (listColumns[columnName]) {
                    this.columns.push(listColumns[columnName])
                }
            }
        }

        // Create our Filter Groups

        const filterGroups: any = {
            'byStatus': this.buildStatus(),
            'byCutoff': this.buildCutoffDate(),
            'byTruckId': this.buildTruckId(),
            'byDealer': this.buildDealer(),
            'byOrderId': this.buildOrderId(),
            'byDate': this.buildDeliveryDate(),
            'byName' : this.buildTruckName(),                                   
            'byDriver' : this.buildDriverName(),
            'byTractor' : this.buildTractorName(),
            'byTrailer' : this.buildTrailerName()
        };

        if (filterNames.length == 0) {
            for (let group in filterGroups) {
                this.filters.push(filterGroups[group]);
            }
        }
        else {
            for (let filterName of filterNames) {
                if (filterGroups[filterName]) {
                    this.filters.push(filterGroups[filterName])
                }
            }
        }

        // Create our Non-Optional Filters
        const byType = this.buildType();
        this.requiredFilters.push(byType);
    }

    // #region Group Builders

    private buildStatus() {        
        const byStatus = new FilterGroup('Status', 'checkboxes', 'status');
        byStatus.opts = AppUtils.enumMetadataToFilters(ShipmentStatusMetadata);
        
        byStatus.opts.forEach((itm : FilterBarInputOpt) => {
            itm.data = (itm.qsValue === 0) ? true : false;
        });

        byStatus.opts = byStatus.opts.filter((itm : FilterBarInputOpt) => {
            return itm.qsValue >= 0;
        });

        return byStatus;
    }

    private buildDeliveryDate() {
        const byDate = new FilterGroup('Delivery Date', 'date', 'date');        
        const opt1 = new FilterBarInputOpt('Delivery Date', undefined);
        
        byDate.opts = [opt1];

        return byDate;
    }

    private buildDealer() {
        const byDealer = new FilterGroup('Dealer', 'dealer', 'dealer');        
        const opt1 = new FilterBarInputOpt('Dealer', '');
        
        byDealer.opts = [opt1];

        return byDealer;
    }

    private buildOrderId() {
        const byOrderId = new FilterGroup('Order ID', 'text', 'order');        
        const opt1 = new FilterBarInputOpt('Order ID', '');
        
        byOrderId.opts = [opt1];

        return byOrderId;
    }

    private buildTruckId() {
        const byTruckId = new FilterGroup('Truck ID', 'numeric', 'id');        
        const opt1 = new FilterBarInputOpt('Truck ID', '');
        
        byTruckId.opts = [opt1];

        return byTruckId;
    }

    private buildTruckName() {
        const byTruckName = new FilterGroup('Name', 'text', 'name');
        const opt1 = new FilterBarInputOpt('Name', '');
        
        byTruckName.opts = [opt1];

        return byTruckName;
    }

    private buildType() {
        const requiredType      = new AppliedFilterBarOpt();
        requiredType.uuid       = '';
        requiredType.label      = 'By Truck';
        requiredType.qsName     = 'type';
        requiredType.qsValue    = ShipmentType.Truck.toString();

        return requiredType;
    }

    private buildCutoffDate() {
        const byDate = new FilterGroup('Cutoff Date', 'date', 'cutoff');        
        const opt1 = new FilterBarInputOpt('Cutoff Date', undefined);
        
        byDate.opts = [opt1];

        return byDate;
    }
    
    private buildDriverName() {
        const byDriverName = new FilterGroup('Driver Name', 'autocomplete', 'driver');
        byDriverName.autoCompleteEndpoint = ApiEndpoints.TRANSPORTATION_FLEET_DRIVERS_AUTOCOMPLETE;
        byDriverName.autoCompleteRender = 'driver';

        const opt1 = new FilterBarInputOpt('Driver Name', '');        
        byDriverName.opts = [opt1];

        return byDriverName;
    }

    private buildTractorName() {
        const byTractorName = new FilterGroup('Tractor', 'autocomplete', 'tractor');
        byTractorName.autoCompleteEndpoint = ApiEndpoints.TRANSPORTATION_FLEET_VEHICLE_AUTOCOMPLETE;

        const opt1 = new FilterBarInputOpt('Tractor', '');        
        byTractorName.opts = [opt1];

        return byTractorName;
    }

    private buildTrailerName() {
        const byTractorName = new FilterGroup('Trailer', 'autocomplete', 'trailer');
        byTractorName.autoCompleteEndpoint = ApiEndpoints.TRANSPORTATION_FLEET_TRAILER_AUTOCOMPLETE;

        const opt1 = new FilterBarInputOpt('Trailer', '');        
        byTractorName.opts = [opt1];

        return byTractorName;
    }

    // #endregion

}
